var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 295,
    viewBox: "0 0 376 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "arrowOne",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.000211717L38.7778 -3.18215e-06L146.287 146.922L146.382 146.991L146.36 147.021L146.382 147.051L146.287 147.12L38.7778 294.042L0 294.042L106.807 147.021L0 0.000211717ZM91.5 0.000214899L130.278 0L130.278 0.000160712L159.278 0L233.691",
    fill: "url(#paint0_linear_2203_655)",
    transform: "translate(50,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "arrowTwo",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.000211717L38.7778 -3.18215e-06L146.287 146.922L146.382 146.991L146.36 147.021L146.382 147.051L146.287 147.12L38.7778 294.042L0 294.042L106.807 147.021L0 0.000211717ZM91.5 0.000214899L130.278 0L130.278 0.000160712L159.278 0L233.691",
    fill: "url(#paint0_linear_2203_655)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "arrowThree",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.000211717L38.7778 -3.18215e-06L146.287 146.922L146.382 146.991L146.36 147.021L146.382 147.051L146.287 147.12L38.7778 294.042L0 294.042L106.807 147.021L0 0.000211717ZM91.5 0.000214899L130.278 0L130.278 0.000160712L159.278 0L233.691",
    fill: "url(#paint0_linear_2203_655)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "main",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.000211717L38.7778 0.000160712L159.278 0L233.691 101.693L308.104 0L337.104 0.000160712L337.104 0L375.882 0.000214899L269.075 147.021L375.882 294.042H346.882L337.104 294.042H308.104L233.691 192.349L159.278 294.042H130.278L120.5 294.042H91.5L198.307 147.021L91.5 0.000214899Z",
    fill: "url(#paint0_linear_2203_655)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2203_655",
    x1: -2.17676e-7,
    y1: 136.519,
    x2: 375.882,
    y2: 136.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#4E4B87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517857,
    stopColor: "#844B88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767857,
    stopColor: "#AA4C8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E14197"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.42e5877a.svg";
export { ForwardRef as ReactComponent };